import { Directive, DoCheck, ElementRef, Input } from '@angular/core';
import { BehaviorSubject, Subject, filter, take } from 'rxjs';

@Directive({
  selector: '[applyClassOnChild]',
  standalone: true,
})
export class ApplyClassOnChildDirective implements DoCheck {

  readonly #destroy = new Subject<void>()


  readonly selectorClassListDictSubject = new BehaviorSubject<Record<string, string[]>>(null)
  @Input('applyClassOnChild') get selectorClassListDict() {
    return this.selectorClassListDictSubject.value
  }
  set selectorClassListDict(value) {
    this.selectorClassListDictSubject.next(value)
  }

  get #element() {
    return this._elementRef.nativeElement
  }

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>
  ) {

  }



  ngDoCheck() {

    this.selectorClassListDictSubject.pipe(
      filter(Boolean),
      take(1)
    )
      .subscribe((selectorClassListDict) => {
        Object.entries(selectorClassListDict).forEach(([selector, classList]) => {
          this.#element.querySelectorAll(selector).forEach(el => el.classList.add(...classList))
        })
      })
  }

  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
